import { ReactComponent as IconChevronDown } from '@/assets/svgs/profile-chevron.svg'
import { ReactComponent as IconInfo} from '@/assets/svgs/icon-info.svg'
import rem from '@/utils/rem'
import classname from 'classnames'
import React, { useCallback, useRef, useState, useEffect } from "react"
import { Manager, Popper, Reference } from "react-popper"
import MultiClamp from 'react-multi-clamp'
import clickCheck from '@/utils/click-check'

export const Toggle = (setOpen, isOpenDropdown) => {
    setOpen(!isOpenDropdown)
}

export function Popover(setListRef, maxWidth, isOpenDropdown, options, label, Select, handleCheckInfo) {
    return <Popper placement="bottom"
        modifiers={[
            {
                name: 'preventOverflow',
                enabled: true
            },
            {
                name: 'offset',
                options: { offset: [0, 6] }
            }
        ]}
    >
        {({ ref, style, placement }) => (
            <div ref={node => setListRef(node, ref)} style={{ ...style, width: maxWidth, maxWidth }} data-placement={placement}
                className={`dropdown__list ${(isOpenDropdown && "dropdown__list--open") || ""}`}>
                {options.map((item, index) => {
                    if( handleCheckInfo ) {
                         return (
                            <div className={label === item.name ? 'dropdown__item dropdown__item__with-info dropdown__item__selected' : 'dropdown__item__with-info dropdown__item'} key={index}>
                                    <div className="dropdown__item__name" onClick={() => Select(item)} >
                                        <span className={'dropdown__item-span__margin'} title={item.name}>{item.name}</span>
                                    </div>

                                    <div className="dropdown__item__info-icon" data-testid={"dropdown_contributor_info_icon"} onClick={(e)=>{
                                        e.stopPropagation();
                                        handleCheckInfo(item)
                                    }
                                    }><IconInfo /></div>
                            </div>
                        )
                    } else {
                        return (
                            <div className={label === item.name ? 'dropdown__item dropdown__item__selected' : 'dropdown__item'} onClick={() => Select(item)} key={index}>
                                <span className={'dropdown__item-span__margin'} title={item.name}>{item.name}</span>
                            </div>
                        )
                    }
                })}
            </div>
        )}
    </Popper>
}

export function SetDataForButtonRef(buttonRef, listRef) {
    const setButtonRef = useCallback((node, ref) => {
        buttonRef.current = node
        return ref(node)
    }, [])

    const setListRef = useCallback((node, ref) => {
        listRef.current = node
        return ref(node)
    }, [])
    return { setButtonRef, setListRef }
}

export function SelectFunction(setOpen, setLabel, submit) {
    return (item) => {
        setOpen(false)
        setLabel(item.name)
        return submit(item)
    }
}

const DropdownContributor = ({ text, value, options, submit, maxWidth, ghost, full, disabled, handleCheckInfo }) => {
    const [isOpenDropdown, setOpen] = useState(false)
    const [label, setLabel] = useState(text)
    const listRef = useRef(null)
    const buttonRef = useRef(null)

    const dropdownContributorStyles = {
        width: rem(maxWidth)
    }

    const dropdownContributorClasses = classname({
        'dropdown__button': true,
        'dropdown__button--modified': true,
        'dropdown__button--disabled': disabled,
        'dropdown__button--ghost': ghost,
        'dropdown__button--full': full
    })

    useEffect(() => {
        const clickCheckCb = (e) => clickCheck(isOpenDropdown, listRef, buttonRef, setOpen, e);
        document.addEventListener('mousedown', clickCheckCb)
        return () => {
            return document.removeEventListener('mousedown', clickCheckCb)
        }
    }, [isOpenDropdown])

    const { setButtonRef, setListRef } = SetDataForButtonRef(buttonRef, listRef)

    const Select = SelectFunction(setOpen, setLabel, submit)

    return (
        <Manager>
            <Reference>
                {({ ref }) => (
                    <div tabIndex="0"
                        className={dropdownContributorClasses}
                        id="openToggle"
                        style={dropdownContributorStyles}
                        ref={node => setButtonRef(node, ref)}
                        onClick={() => Toggle(setOpen, isOpenDropdown)}
                    >
                        <div className={"dropdown__label__selected"}><MultiClamp clamp={1}>{value || label}</MultiClamp></div>
                        <div><IconChevronDown /></div>
                    </div>
                )}
            </Reference>
            {isOpenDropdown && (
                Popover(setListRef, maxWidth, isOpenDropdown, options, label, Select, handleCheckInfo)
            )}
        </Manager>
    )
}

export default DropdownContributor
